<template>
  <div class="app-wrapper">
    <v-head></v-head>
    <div class="bottomBox">
      <sidebar class="left" />
      <app-main class="right" />
    </div>
  </div>
</template>
<script>
import { Sidebar, AppMain } from "./components";
import vHead from "@/components/vhead";
export default {
  name: "Layout",
  components: {
    Sidebar,
    AppMain,
    vHead
  }
};
</script>
<style lang="scss">
.app-wrapper {
  .bottomBox {
    padding: 54px 0 0;
    display: flex;
    justify-content: space-between;
    .sideber.left {
      width: 200px;
    }
    .app-main.right {
      width: calc(100% - 200px);
    }
  }
}
</style>
